import { useState } from "react";
import axiosMain from "../../http/axiosMain";
import { showErrorToast, showSuccessToast } from "../../../utils/functions";

export const useUpdateInfluencerStatus = () => {
  const [loading, setLoading] = useState(false);

  const updateInfluencerStatus = async ({ id, status }, onUpdate) => {
    setLoading(true);
    try {
      let url = "/api/admin/influencers/update-influencer-status";

      const resp = await axiosMain.post(url, { id, status });

      if (resp.data.success) {
        showSuccessToast("Influencer status updated successfully.");
        onUpdate();
      } else {
        showErrorToast("Something went wrong.");
      }
    } catch (err) {
      console.error(err);
      showErrorToast(
        err?.response?.data?.message || err?.message || "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    updateInfluencerStatus,
    loading,
  };
};
